import { useCallback, useRef, useState } from 'react';
import EditorImagePurposeModal, { type EditorImagePurpose } from '../components/editor/EditorImagePurposeModal';

type Ask = {
  preview?: string;
  label?: string;
  remaining: number;
};

export function useImagePurposePrompt() {
  const [ask, setAsk] = useState<Ask | null>(null);
  const resolveRef = useRef<((value: EditorImagePurpose | null) => void) | undefined>(undefined);

  const promptPurpose = useCallback((args: { preview?: string; label?: string; remaining?: number }) => {
    return new Promise<EditorImagePurpose | null>((resolve) => {
      resolveRef.current = resolve;
      setAsk({
        preview: args.preview,
        label: args.label,
        remaining: args.remaining ?? 1,
      });
    });
  }, []);

  const finish = (value: EditorImagePurpose | null) => {
    const resolve = resolveRef.current;
    resolveRef.current = undefined;
    setAsk(null);
    resolve?.(value);
  };

  const modal = (
    <EditorImagePurposeModal
      open={!!ask}
      preview={ask?.preview}
      label={ask?.label}
      remaining={ask?.remaining}
      onPick={(purpose) => finish(purpose)}
      onClose={() => finish(null)}
    />
  );

  return { promptPurpose, modal, asking: !!ask };
}
